export enum NaturePiece {
    CNI = 'CNI',
    PASSEPORT = 'Passeport',
    PERMIS_CONDUIRE = 'Permis de conduire',
    ATTESTATION_IDENTITE = "Attestation d'identité",
    CARTE_CONSULAIRE = 'Carte consulaire',
    CARTE_RESIDENT = 'Carte de résident',
    CARTE_SEJOUR = 'Carte de séjour',
    CARTE_PROFESSIONNELLE = 'Carte professionnelle',
}
